import {BookingModal} from '../bookingModal/BookingModal';
import ModalPortal from 'src/components/layout/modal/ModalPortal';
import {DropinModal} from '../dropinModal/DropinModal';
import {useTranslation} from 'react-i18next';

export type ArrivalPopupAction = 'booking' | 'dropin';
interface ModalContainerProps {
    popup?: ArrivalPopupAction;
    onClose?: VoidFunction;
}

export function ModalContainer({popup, onClose}: ModalContainerProps) {
    const {t} = useTranslation();

    return (
        <>
            {popup === 'booking' && (
                <ModalPortal headerTitle={t('arrival.booking_header')} onCloseClick={onClose} size='large'>
                    <BookingModal onClose={onClose} />
                </ModalPortal>
            )}

            {popup === 'dropin' && (
                <ModalPortal headerTitle={t('arrival.dropin_header')} onCloseClick={onClose} size='large'>
                    <DropinModal onClose={onClose} />
                </ModalPortal>
            )}
        </>
    );
}
